<template>
  <div style="display: flex; align-items: center">
    <CheckCircle class="suus-activation-icon" v-if="state === 'success'" />
    <CloseCircle class="suus-activation-icon" v-else-if="state === 'error'" />
    <HourglassCircle
      class="suus-activation-icon"
      :class="{ 'suus-hourglass-active': state === 'active' }"
      v-else
    />
    <TextBody
      :font-size="0.875"
      custom-class="suus-activation-text"
      :class="textClasses"
      style="margin-left: 8px"
    >
      {{ text }}
    </TextBody>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import HourglassCircle from "./assets/HourglassCircle.svg"
import CheckCircle from "./assets/CheckCircle.svg"
import CloseCircle from "./assets/CloseCircle.svg"
import TextBody from "components/UI/TextBody.vue"

export type State = "waiting" | "active" | "error" | "success"

export default defineComponent({
  name: "ActivationWizardStep",
  components: { TextBody, HourglassCircle, CheckCircle, CloseCircle },
  props: {
    text: {
      type: String,
      required: true,
    },
    state: {
      type: String as PropType<State>,
      required: true,
    },
  },
  computed: {
    textClasses(): object {
      return {
        "suus-activation-success": this.state === "success",
        "suus-activation-failure": this.state === "error",
        "suus-activation-waiting": this.state === "waiting",
        "suus-activation-active": this.state === "active",
      }
    },
  },
  setup() {
    return {}
  },
})
</script>

<style>
.suus-activation-icon {
  flex-shrink: 0;
}

.suus-hourglass-active {
  animation: spin 2s ease-in-out infinite;
}

.suus-hourglass-active path {
  fill: #307ef7;
}

.suus-activation-success {
  color: #22d563 !important;
}

.suus-activation-failure {
  color: #b00020 !important;
}

.suus-activation-text {
  font-weight: 500;
}

.suus-activation-waiting {
  color: #c7c7c7 !important;
}

.suus-activation-active {
  color: #307ef7 !important;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  80% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
